import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './CaptchaBox.module.css';

interface CaptchaBoxProps {
  onVerify: (token: string | null) => void;
}

const CaptchaBox: React.FC<CaptchaBoxProps> = ({ onVerify }) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  // Skip reCAPTCHA on localhost - automatically verify
  React.useEffect(() => {
    if (isLocalhost) {
      onVerify('localhost-bypass-token');
    }
  }, [isLocalhost, onVerify]);

  if (!siteKey || isLocalhost) {
    if (isLocalhost) {
      return (
        <div className={styles.captchaInfo}>
          ℹ️ reCAPTCHA bypassed for localhost development
        </div>
      );
    }
    console.error('VITE_RECAPTCHA_SITE_KEY is not defined in environment variables');
    return (
      <div className={styles.captchaError}>
        reCAPTCHA configuration error. Please contact support.
      </div>
    );
  }

  const handleChange = (token: string | null) => {
    onVerify(token);
  };

  const handleExpired = () => {
    onVerify(null);
  };

  const handleError = () => {
    onVerify(null);
    console.error('reCAPTCHA encountered an error');
  };

  return (
    <div className={styles.captchaWrapper}>
      <div className={styles.captchaContainer}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={handleChange}
          onExpired={handleExpired}
          onErrored={handleError}
          theme="dark"
          size="normal"
        />
      </div>
    </div>
  );
};

export default CaptchaBox;
